import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataUtils {
  byteSize(base64String: string): string {
    if (!base64String) {
      return '0 bytes';
    }
    const size = (base64String.length / 4) * 3;
    return `${Math.round(size)} bytes`;
  }

  openFile(contentType: string | null, data: string): void {
    if (!data) {
      return;
    }
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType ?? '' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  downloadFile(contentType: string | null, data: string, fileName = 'download'): void {
    if (!data) {
      return;
    }
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType ?? '' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  toBase64(file: Blob, callback: (base64Data: string) => void): void {
    const reader = new FileReader();
    reader.onload = () => {
      const base64Data = (reader.result as string).split(',')[1] ?? '';
      callback(base64Data);
    };
    reader.readAsDataURL(file);
  }
}
